import React, { useCallback, useEffect, useRef, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import "react-datepicker/dist/react-datepicker.css";
import Gallery from "../common/gallery/gallery";
import ProductMenu from "./productMenu";
import { useForm } from "react-hook-form";
import { _Api } from "../api/_call";
import { loading, Updateloading } from "../common/helpers/toastify";
// import { toFormatPrice, toUnformatPrice, numberFormatter } from "../common/helpers/function";
import {
  toFormatPrice,
  numberFormatter,
} from "../../Helper/PriceHelper";

import {
  MetalsList,
  ColorsList,
  SizesList,
  UnitSelect,
  patchStoneAt,
} from "../product/masters";
import ProductAdvancedPricing from "./ProductAdvancedPricing";
import ProductAdvancedOtherDetails from "./ProductAdvancedOtherDetails";
import ProductAdvancedStoneRow from "./ProductAdvancedStoneRow";
import ProductAdvancedStoneSidebar from "./ProductAdvancedStoneSidebar";
import {
  flushActiveFieldBeforeSave,
  mergeHookFormStoneFields,
  syncPricingFieldsFromDom,
  syncStoneBlurFieldsFromDom,
} from "./productAdvancedSaveSync";
import "./product.scss";
import { useTranslation } from "react-i18next";
const ProductAdvanced = (props) => {
  const { t } = useTranslation();
  const [call, setcall] = useState("");
  const base_assets = process.env.REACT_APP_BASE_ASSETS_URL;
  const { register, handleSubmit, reset, setValue } = useForm();

  const { productId_url } = useParams();
  const location = useLocation();
  const stateProductArr = location.state?.product_value_arr;
  const [IsDisable, setIs_disable] = useState(false);
  var setected_opt_ = {
    generalInfo: "",
    advanced: "active",
    variant: "",
    choice: "",
  };
  const [setected_opt] = useState(setected_opt_);
  const [possi_css, setPossi_css] = useState([]);
  const [formValues_stone, setFormValues_stone] = useState([{}]);
  const pricingValuesRef = useRef([{}]);
  const otherDetailsValuesRef = useRef([{ location: "" }]);
  const [initialPricing, setInitialPricing] = useState(null);
  const [initialOtherDetails, setInitialOtherDetails] = useState(null);
  //master values props
  const [additional_image_form, setImages_product] = useState([]);
  const [, set_stoneGroup] = useState("");
  const [selectedButton, setButton] = useState("");
  const [isSavingAdvanced, setIsSavingAdvanced] = useState(false);
  const isSavingAdvancedRef = useRef(false);
  const [formValues_metal, setFormValues_metal] = useState("");
  const [formValues_color, setFormValues_color] = useState("");
  const [formValues_size, setFormValues_size] = useState("");
  const [, setDesignValue] = useState([]);
  const [formShape_ids, setShape_ids] = useState([]);
  const [, setVarientType] = useState([]);
  const [productsImages, setproductsImages] = useState("");
  const [OrgCurrency, setOrgCurrency] = useState("");
  const [deleteAllAddImage, setDeleteAllAddImage] = useState(false);

  const [formUnit, setUnit] = useState("");

  const [advanceProductData, setAdvanceProductData] = useState([
    { Size: "", Metal: "", Color: "" },
  ]);

  const [product_value_arr_advance, setproduct_value_arr_advance] = useState(
    stateProductArr?.length ? stateProductArr : [{}]
  );
  const [varient_image, setVarient_image] = useState("");
  const [product_value_arr, setproduct_value_arr_val] = useState(
    stateProductArr?.length
      ? stateProductArr
      : [{ product_id: productId_url || "", name: "", varient_type: "" }]
  );
  const getProductUrl_details = useCallback(async () => {
    if (productId_url !== undefined) {
      try {
        const postdata = {
          id: productId_url,
        };
        let resPoOrders = await _Api(
          postdata,
          `api/v1/APP/product/getProductType`
        );
        if (resPoOrders.code === 200) {
          setproduct_value_arr_val(resPoOrders.data);
        } else {
        }
      } catch (err) {
        console.log(err, "err");
      }
    }
  }, [productId_url]);

  //end
  const addFormFields_stone = useCallback(() => {
    setFormValues_stone((prev) => [
      ...prev,
      {
        StoneGroup: "",
        Stone: "",
        StoneVariant: "",
        StoneShape: "",
        StoneCut: "",
        StoneClarity: "",
        StoneColor: "",
        stoneSize: "",
        certificate: "",
        Certificatetype: "",
        certificateNo: "",
        Weight: "",
        WeightType: "",
        Pcs: "",
        setting_type: "",
        stonePrice: "",
      },
    ]);
    setPossi_css_call();
  }, []);
  const removeFormFields_stone = useCallback((i) => {
    setFormValues_stone((prev) => {
      const next = [...prev];
      next.splice(i, 1);
      return next;
    });
  }, []);

  const arrayColumn = (arr_, index) => {
    if (JSON.stringify(arr_[0]) !== "{}") {
      return arr_?.map((val) => val[index]);
    } else {
      return [];
    }
  };
  const callcertificatenumber = useCallback((value, index, name) => {
    patchStoneAt(setFormValues_stone, index, { [name]: value });
  }, []);
  const onSubmit = async (data) => {
    if (isSavingAdvancedRef.current) {
      return;
    }

    // Ensure blur-controlled fields are committed before building the payload.
    await flushActiveFieldBeforeSave();

    isSavingAdvancedRef.current = true;
    setIsSavingAdvanced(true);
    let GetloadingID = loading();
    setButton("pe-none ct-disable");
    data.Metal = formValues_metal;
    data.Color = formValues_color;
    data.Size = formValues_size;
    data.PriceDetails = syncPricingFieldsFromDom(
      pricingValuesRef.current ? pricingValuesRef.current : []
    );
    data.stones = mergeHookFormStoneFields(
      syncStoneBlurFieldsFromDom(formValues_stone),
      data
    );
    data.OtherDetails = otherDetailsValuesRef.current
      ? otherDetailsValuesRef.current
      : [];
    data.product_id = product_value_arr[0].product_id;
    data.Unit = formUnit;
    data.additional_product_image = arrayColumn(
      additional_image_form,
      "data_url"
    );
    data.deleteAllAddImage = deleteAllAddImage;
    try {
      const postdata = data;
      let resPoOrders = await _Api(postdata, `api/v1/APP/product/saveAdvance`);
      if (resPoOrders.code === 200) {
        Updateloading(t, GetloadingID, t(resPoOrders.message));
        setButton("pe-none ct-disable");
      } else {
        setButton("ErrorShowBtn");
        Updateloading(t, GetloadingID, resPoOrders?.errors, "error");
      }
    } catch (err) {
      Updateloading(t, GetloadingID, t("something went wrong"), "error");
      setButton("ErrorShowBtn");
    } finally {
      isSavingAdvancedRef.current = false;
      setIsSavingAdvanced(false);
    }
  };

  useEffect(() => {
    if (product_value_arr) {
      setproduct_value_arr_advance(product_value_arr);
      getAdvance();
      let formValues_stone_val = [...formValues_stone];
      setFormValues_stone(formValues_stone_val);
      setVarientType(product_value_arr[0]?.varient_type);
      getVarientImage(product_value_arr[0].varient_type);
    }
    // eslint-disable-next-line
  }, [product_value_arr]);

  useEffect(() => {
    if (product_value_arr[0]?.product_id) {
      setIs_disable("pe-none  ct-disable");
    }
  }, [product_value_arr]);
  const getAdvance = async () => {
    try {
      const postdata = {
        id: product_value_arr[0].product_id,
      };
      let resPoOrders = await _Api(postdata, `api/v1/APP/product/getAdvance`);
      if (resPoOrders.code === 200) {
        var response = resPoOrders?.data ? resPoOrders?.data : [];
        var responseImages = resPoOrders?.images ? resPoOrders?.images : [];
        var responseCurrency = resPoOrders?.currency
          ? resPoOrders?.currency
          : [];
        setproductsImages(responseImages);
        setOrgCurrency(responseCurrency);
        var StoneGroup = response.StoneGroup ? response?.StoneGroup[0] : [];
        if (StoneGroup?.length) {
          setFormValues_stone([]);
        }
        var data_stone = [];
        resPoOrders?.data?.Stones?.forEach((element, index) => {
          data_stone.push({
            StoneGroup: element?.stone_group,
            Stone: element?.stone,
            StoneVariant: element?.Variant,
            Stone_Variant: element?.Variant,
            StoneShape: element?.shape,
            StoneCut: element?.Cut,
            StoneClarity: element?.clarity,
            StoneColor: element?.color,
            stoneSize: element?.Size,
            certificate: element?.certificate.type,
            Certificatetype: element?.certificate.type,
            certificateNo: element?.certificate.number,
            Weight: element?.Cts,
            WeightType: element?.Unit,
            Pcs: element?.Pcs,
            setting_type: element?.setting_type,
            stonePointer: element?.Pointer,
            stonePrice: element?.Price,
          });
        });

        if (data_stone?.length) {
          setFormValues_stone(data_stone);
        }

        setAdvanceProductData(resPoOrders.data);
        setFormValues_size(response.Size);
        setFormValues_color(response.Color);
        setFormValues_metal(response.Metal);
        setUnit(response.Unit);
        if (resPoOrders.data.PriceDetails) {
          const formattedPriceDetails = resPoOrders.data.PriceDetails.map(
            (item) => ({
              ...item,
              retailprice_Ex: toFormatPrice(item.retailprice_Ex || 0),
              retailprice_Inc: toFormatPrice(item.retailprice_Inc || 0),
              inv_retailprice_Ex: toFormatPrice(item.inv_retailprice_Ex || 0),
              inv_retailprice_Inc: toFormatPrice(item.inv_retailprice_Inc || 0),
            })
          );
          pricingValuesRef.current = formattedPriceDetails;
          setInitialPricing(formattedPriceDetails);
        }

        if (resPoOrders.data.OtherDetails?.length) {
          otherDetailsValuesRef.current = resPoOrders.data.OtherDetails;
          setInitialOtherDetails(resPoOrders.data.OtherDetails);
        } else {
          const emptyRow = [{ location: "" }];
          otherDetailsValuesRef.current = emptyRow;
          setInitialOtherDetails(emptyRow);
        }
      } else {
      }
    } catch (err) {
      console.log(err, "err1");
    }
  };
  useEffect(() => {
    const timer = setTimeout(() => {
      setcall(1);
    }, 500);
    return () => clearTimeout(timer);
  }, []);
  useEffect(() => {
    reset(advanceProductData);
    // eslint-disable-next-line
  }, [advanceProductData]);
  const getVarientImage = (type) => {
    var image = "";
    if (type === 1) {
      image = base_assets + "images/icons/variant-sm.png";
    } else if (type === 2) {
      image = base_assets + "images/pro-ring-img.png";
    }
    setVarient_image(image);
  };
  const setPossi_css_call = () => {
    let product_stone_posi = [];
    const timer = setTimeout(() => {
      for (let i = 0; i < 300; i++) {
        let dataStone_ = document.querySelector("#dataStone_" + i);
        if (dataStone_) {
          let dataStone_O = dataStone_.offsetTop;
          product_stone_posi.push(dataStone_O);
        }
      }
      setPossi_css(product_stone_posi);
    }, 5000);
    return () => clearTimeout(timer);
  };
  useEffect(() => {
    getProductUrl_details();
    setPossi_css_call();
  }, [getProductUrl_details]);

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
    }
  };
  useEffect(() => {
    if (advanceProductData) {
      setValue("GrossWt", numberFormatter(advanceProductData.GrossWt || 0));
      setValue("NetWt", numberFormatter(advanceProductData.NetWt || 0));
      setValue("labor", toFormatPrice(advanceProductData.labor || 0));
      setValue("CostPrice", toFormatPrice(advanceProductData.CostPrice || 0));
    }
  }, [advanceProductData]);

  return (
    <React.Fragment key="1">
      <div className="main-body product-tab-page-padding-top">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <form onSubmit={handleSubmit(onSubmit)}>
                <div className="sticky-top-product-page">
                <ProductMenu
                  product_value_arr={product_value_arr_advance}
                  setected_opt={setected_opt}
                  selectedButton_={selectedButton}
                  setSelectedButton_={setButton}
                  isSaving_={isSavingAdvanced}
                  setIs_disable={setIs_disable}
                  productId_url={productId_url}
                  />
                  </div>
                <div className={"product-ct-wrap product-pt " + IsDisable}>
                  <div className="product-ct-wrap-col-left col-left-wrap">
                    <div className="product-com-box-layout">
                      <div className="product-ct-wrap-col-left-name">
                        <h1 className="product-ct-wrap-col-left-name-text">
                          # {product_value_arr_advance[0]?.name}
                        </h1>
                        <h1 className="product-ct-wrap-col-left-name-text ms-auto">
                          {product_value_arr[0]?.sku}
                        </h1>

                        <img
                          className="product-ct-wrap-col-left-name-img"
                          src={varient_image}
                          alt=""
                        />
                      </div>
                      <div className="row product-ct-wrap-col-left-input-select-wrap mb-5">
                        <h4 className="pro-sub-heading">{t("Metal")}</h4>
                        <div className="col-xl-7 col-md-12 product-ct-wrap-col-left-input-select-wrap-input">
                          <div className="row gx-2">
                            <div className="col-md-4">
                              <div className="placeholder-up-input w-100">
                                {call ? (
                                  <MetalsList
                                    setstatusSelectedOptions={
                                      setFormValues_metal
                                    }
                                    setFormValues_color={setFormValues_color}
                                    selected_id={formValues_metal}
                                    requiredMark={
                                      String(product_value_arr?.[0]?.varient_type) !== "3"
                                    }
                                  ></MetalsList>
                                ) : (
                                  ""
                                )}
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="placeholder-up-input w-100">
                                {call ? (
                                  <ColorsList
                                    setstatusSelectedOptions={
                                      setFormValues_color
                                    }
                                    selected_id={formValues_color}
                                    requiredMark={
                                      String(product_value_arr?.[0]?.varient_type) !== "3"
                                    }
                                  ></ColorsList>
                                ) : (
                                  ""
                                )}
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="placeholder-up-input w-100">
                                {call ? (
                                  <SizesList
                                    setstatusSelectedOptions={
                                      setFormValues_size
                                    }
                                    prodoct_id={productId_url}
                                    selected_id={formValues_size}
                                  ></SizesList>
                                ) : (
                                  ""
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {call
                      ? formValues_stone?.map((element, index) => (
                          <ProductAdvancedStoneRow
                            key={index}
                            element={element}
                            index={index}
                            stoneCount={formValues_stone.length}
                            isLast={index === formValues_stone.length - 1}
                            varientType={product_value_arr[0]?.varient_type}
                            set_stoneGroup={set_stoneGroup}
                            setFormValues_stone={setFormValues_stone}
                            setShape_ids={setShape_ids}
                            setDesignValue={setDesignValue}
                            setAdvanceProductData={setAdvanceProductData}
                            onFieldChange={callcertificatenumber}
                            onAdd={addFormFields_stone}
                            onRemove={removeFormFields_stone}
                            base_assets={base_assets}
                          />
                        ))
                      : ""}

                    <div className="product-com-box-layout tablet">
                      {/* <div className="row  mb-5">
                        <h4 className="pro-sub-heading">
                          {t("Additional product image")}
                        </h4>
                        <div className="col-md-12">
                          <div className="gallery-upload-area"> */}
                      <Gallery
                        setImages_product={setImages_product}
                        setproductsImages={productsImages}
                        setDeleteAllAddImage={setDeleteAllAddImage}
                        disabled={Boolean(IsDisable)}
                      />
                      {/* </div>
                        </div>
                      </div> */}

                      <ProductAdvancedOtherDetails
                        call={call}
                        initialOtherDetails={initialOtherDetails}
                        valuesRef={otherDetailsValuesRef}
                      />
                      <ProductAdvancedPricing
                        call={call}
                        initialPricing={initialPricing}
                        valuesRef={pricingValuesRef}
                      />
                    </div>
                  </div>

                  <div className="product-ct-wrap-col-right">
                    <div className="product-sidebar-box box-bg box-input-40">
                      <div className="product-sidebar-box-form">
                        <table>
                          <tbody>
                            <tr>
                              <td>
                                <label>{t("Gross Wt")}</label>
                              </td>
                              <td>
                                <div className="placeholder-up-input w-100">
                                  <input
                                    {...register("GrossWt", {
                                      onBlur: (e) => {
                                        setValue(
                                          "GrossWt",
                                          numberFormatter(
                                            e.target.value ? e.target.value : 0
                                          )
                                        );
                                      },
                                    })}
                                    className="box-input"
                                    onKeyPress={handleKeyPress}
                                  />
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <label>{t("Net Wt")}</label>
                              </td>
                              <td>
                                <div className="placeholder-up-input w-100">
                                  <input
                                    {...register("NetWt", {
                                      onBlur: (e) => {
                                        setValue(
                                          "NetWt",
                                          numberFormatter(
                                            e.target.value ? e.target.value : 0
                                          )
                                        );
                                      },
                                    })}
                                    className="box-input"
                                    onKeyPress={handleKeyPress}
                                  />
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <label>
                                  {t("Labor")} ({OrgCurrency})
                                </label>
                              </td>
                              <td>
                                <div className="placeholder-up-input w-100">
                                  <input
                                    {...register("labor", {
                                      onBlur: (e) => {
                                        setValue(
                                          "labor",
                                          toFormatPrice(
                                            e.target.value ? e.target.value : 0
                                          )
                                        );
                                      },
                                    })}
                                    className="box-input"
                                    onKeyPress={handleKeyPress}
                                  />
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <label>
                                  {t("Cost Price")} ({OrgCurrency})
                                </label>
                              </td>
                              <td>
                                <div className="placeholder-up-input w-100">
                                  <input
                                    {...register("CostPrice", {
                                      onBlur: (e) => {
                                        setValue(
                                          "CostPrice",
                                          toFormatPrice(
                                            e.target.value ? e.target.value : 0
                                          )
                                        );
                                      },
                                    })}
                                    className="box-input"
                                    onKeyPress={handleKeyPress}
                                  />
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <label>{t("Unit")}</label>
                              </td>
                              <td>
                                <div className="placeholder-up-input w-100">
                                  <UnitSelect
                                    setUnit={setUnit}
                                    selected_id={formUnit}
                                  />
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                    {call
                      ? formValues_stone?.map((element, index) => {
                          let poss = "";
                          if (
                            possi_css[index] !== undefined &&
                            possi_css[index]
                          ) {
                            poss = possi_css[index] - 200;
                          }
                          return (
                            <ProductAdvancedStoneSidebar
                              key={index}
                              element={element}
                              index={index}
                              topOffset={poss}
                              productVariantsEnable={
                                advanceProductData?.product_variants_enable
                              }
                              shapeId={
                                formShape_ids[index] || element?.StoneShape
                              }
                              setFormValues_stone={setFormValues_stone}
                              onFieldChange={callcertificatenumber}
                              setValue={setValue}
                              register={register}
                            />
                          );
                        })
                      : ""}
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ProductAdvanced;
